<ngx-app-bar
  class="w-100"
  [title]="'قوانین و مقررات'"
  [rightButton]="{
    icon: 'arrow-right',
    style: 'neutral-link',
    mode: 'icon-only',
    size: 'medium',
  }"
  (onRightButtonClick)="onBackHandler()"
/>

@if (loading) {
  <div class="loading-container">
    <app-spinner></app-spinner>
  </div>
} @else {
  <div class="container">
    <p>قبل از سرمایه‌گذاری این مطالب را مطالعه کنید:</p>

    <div class="stepper">
      @for (item of agreements; track $index) {
        <div class="step">
          <div class="circle"></div>
          <span>
            {{ item }}
          </span>
        </div>
      }
    </div>

    <div class="purchase-agreement-checkbox">
      <ngx-checkbox
        class="purchase-agreement"
        (checkedChange)="onToggleAgreement($event)"
        [(checked)]="agreementChecked"
      >
      </ngx-checkbox>
      <div class="agreement-text">
        <span>موارد فوق و </span>
        <span>شرایط</span>
        <span
          (click)="agreementView(pdfType.REGULATIONS)"
          class="prospectus-text"
        >
          قوانین و مقررات ETF
        </span>
        <span>را می‌پذیرم.</span>
      </div>
    </div>

    <div class="button-container">
      <ngx-button
        [style]="'fill'"
        [fullWidth]="true"
        [size]="'medium'"
        [disabled]="!agreementChecked || btnLoading"
        [isLoading]="btnLoading"
        (clickHandler)="continue()"
        [buttonId]="'IPO_CONFIRM_CONDITIONS'"
      >
        تایید و ادامه
      </ngx-button>
    </div>
  </div>
}
